import {Result} from "neverthrow"
import {ErrorDocument, getResource, OkDocument} from "./common"

export enum UnifiedApplicationStatus {
	Pending = "Pending",
	AwaitingDocuments = "AwaitingDocuments",
	AwaitingIdentityVerification = "AwaitingIdentityVerification",
	Submitted = "Submitted",
	InReview = "InReview",
	Approved = "Approved",
	PartiallyApproved = "PartiallyApproved",
	Rejected = "Rejected",
	Error = "Error",
	Cancelled = "Cancelled",
}

export type UnifiedApplicationChildStatus = Exclude<
	UnifiedApplicationStatus,
	UnifiedApplicationStatus.PartiallyApproved
>

export enum UnifiedApplicationChildType {
	Unit = "Unit",
	Stripe = "Stripe",
	Nium = "Nium",
}

export enum UnifiedApplicationCustomerType {
	Business = "Business",
	SoleProprietor = "SoleProprietor",
}

export type UnifiedApplicationChild = {
	type: "childApplicationDTO"
	id: string
	attributes: {
		createdAt: string
		sourceSystemId: string
		status: UnifiedApplicationChildStatus
		type: UnifiedApplicationChildType
	}
}

export type UnifiedApplication = {
	type: "businessUnifiedApplication" | "solePropUnifiedApplication"
	id: string
	attributes: {
		createdAt: string
		status: UnifiedApplicationStatus
		customerId?: string
		contactFullName?: {first: string; last: string}
		contactEmail?: string
		children: UnifiedApplicationChild[]
	}
	relationships: {
		org: {data: {type: "org"; id: string}}
	}
}

export enum UnifiedApplicationsColumns {
	id = "Id",
	type = "Type",
	org = "Org",
	contactEmail = "Contact Email",
	status = "Status",
	unitApplication = "Unit Application",
	processorApplication = "Processor Application",
	createdAt = "Created At",
}

export type AllowedUnifiedApplicationsColumns = UnifiedApplicationsColumns

export async function findUnifiedApplications(
	accessToken: string,
	offset: number,
	limit: number,
	orgId?: string,
	customerType?: UnifiedApplicationCustomerType
): Promise<Result<OkDocument<Array<UnifiedApplication>>, ErrorDocument>> {
	const query = {
		page: {limit, offset},
		filter: {
			orgId: orgId || null,
			customerType: customerType || null,
		},
	}

	return await getResource<Array<UnifiedApplication>>("unified-applications", accessToken, query)
}

export async function getUnifiedApplication(accessToken: string, id: string) {
	return await getResource<UnifiedApplication>("unified-applications/" + id, accessToken)
}
